// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "" + chunkId + ".580900dadb47b6dd1bee46197ab512bbf2f5e82a.chunk.bundle.js";
};